// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1gxnG","controls":"styles_controls__2YvjA","delete":"styles_delete__2y-HH"};